import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion2 from '../../../../ui/images/questions/ela/grade-k5/question-2.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k5/question-5.png'
import imgQuestion12 from '../../../../ui/images/questions/ela/grade-k5/question-12.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k5_1',
    title: 'Listen to this sentence:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“Well, that was just great,” he said with a frown.',
    sentence: 'What does he most likely mean?',
    answers: [
      {
        name: 'grade_k5_1_a',
        text: 'He is truly happy.',
      },
      {
        name: 'grade_k5_1_b',
        text: 'He is being sarcastic.',
        correct: true,
      },
      {
        name: 'grade_k5_1_c',
        text: 'He is giving a compliment.',
      },
    ],
  },
  {
    name: 'grade_k5_2',
    title: 'If your teacher says, “Please speak clearly so everyone can understand you,” what should you do?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    image: imgQuestion2,
    answers: [
      {
        name: 'grade_k5_2_a',
        text: 'Whisper your answer.',
      },
      {
        name: 'grade_k5_2_b',
        text: 'Talk at a steady pace and pronounce words carefully.',
        correct: true,
      },
      {
        name: 'grade_k5_2_c',
        text: 'Say it quickly and quietly.',
      },
    ],
  },
  {
    name: 'grade_k5_3',
    title: 'What does it mean if someone says, “I’m all ears”?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k5_3_a',
        text: 'They don’t want to listen.',
      },
      {
        name: 'grade_k5_3_b',
        text: 'They are listening carefully.',
        correct: true,
      },
      {
        name: 'grade_k5_3_c',
        text: 'They are confused.',
      },
    ],
  },
  {
    name: 'grade_k5_4',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Although the sky was cloudy, Maya decided to bring her sunglasses. She remembered the forecast said it might clear up later.',
    sentence: 'Why did Maya bring her sunglasses?',
    answers: [
      {
        name: 'grade_k5_4_a',
        text: 'It was already sunny.',
      },
      {
        name: 'grade_k5_4_b',
        text: 'She thought the weather might improve.',
        correct: true,
      },
      {
        name: 'grade_k5_4_c',
        text: 'She wanted to show off her new sunglasses.',
      },
    ],
  },
  {
    name: 'grade_k5_5',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Ben couldn’t believe his luck. He had won the grand prize in the art contest after weeks of hard work and late nights.',
    sentence: 'How did Ben most likely feel?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k5_5_a',
        text: 'Tired and angry',
      },
      {
        name: 'grade_k5_5_b',
        text: 'Surprised and proud',
        correct: true,
      },
      {
        name: 'grade_k5_5_c',
        text: 'Sad and nervous',
      },
    ],
  },
  {
    name: 'grade_k5_6',
    title: 'Read the text:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'The forest was alive with the sound of birds, the rustling of leaves, and the distant splash of a stream. Elena took a deep breath and smiled.',
    sentence: 'What can we infer about how Elena feels?',
    answers: [
      {
        name: 'grade_k5_6_a',
        text: 'She is scared.',
      },
      {
        name: 'grade_k5_6_b',
        text: 'She is lost.',
      },
      {
        name: 'grade_k5_6_c',
        text: 'She is happy and peaceful.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_7',
    title: 'Which of the following sentences is the most descriptive?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k5_7_a',
        text: 'The dog ran.',
      },
      {
        name: 'grade_k5_7_b',
        text: 'The brown dog sprinted across the field, barking loudly.',
        correct: true,
      },
      {
        name: 'grade_k5_7_c',
        text: 'The dog is fast.',
      },
    ],
  },
  {
    name: 'grade_k5_8',
    title: 'Choose the sentence that is written correctly:',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k5_8_a',
        text: 'my sister loves to read, she has many books.',
      },
      {
        name: 'grade_k5_8_b',
        text: 'My sister loves to read she has many books.',
      },
      {
        name: 'grade_k5_8_c',
        text: 'My sister loves to read. She has many books.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_9',
    title: 'Which is the best way to combine these two sentences?',
    topic: AssessmentTopics.Writing,
    detail: 'The sun was shining. We went to the park.',
    answers: [
      {
        name: 'grade_k5_9_a',
        text: 'The sun was shining, we went to the park.',
      },
      {
        name: 'grade_k5_9_b',
        text: 'Since the sun was shining, we went to the park.',
        correct: true,
      },
      {
        name: 'grade_k5_9_c',
        text: 'The sun was shining we went to the park.',
      },
    ],
  },
  {
    name: 'grade_k5_10',
    title: 'Identify the preposition in this sentence:',
    topic: AssessmentTopics.Language,
    detail: 'The cat slept under the warm blanket.',
    answers: [
      {
        name: 'grade_k5_10_a',
        text: 'cat',
      },
      {
        name: 'grade_k5_10_b',
        text: 'slept',
      },
      {
        name: 'grade_k5_10_c',
        text: 'under',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k5_11',
    title: 'Choose the sentence with correct subject-verb agreement:',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k5_11_a',
        text: 'They goes to the store every Saturday.',
      },
      {
        name: 'grade_k5_11_b',
        text: 'They go to the store every Saturday.',
        correct: true,
      },
      {
        name: 'grade_k5_11_c',
        text: 'They going to the store every Saturday',
      },
    ],
  },
  {
    name: 'grade_k5_12',
    title: 'Which word is an adverb in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The student quickly finished the test and handed it in.',
    image: imgQuestion12,
    answers: [
      {
        name: 'grade_k5_12_a',
        text: 'student',
      },
      {
        name: 'grade_k5_12_b',
        text: 'quickly',
        correct: true,
      },
      {
        name: 'grade_k5_12_c',
        text: 'finished',
      },
    ],
  },
]
